// extracted by mini-css-extract-plugin
export default {"uploadBtn":"uploadBtn_uploadBtn__79OtE"};